module.exports = __webpack_public_path__ + "d7e8f0fc07b01eb2f2fa6f4b0e9faad7.svg";